import { render, staticRenderFns } from "./MemberDetailPortfolioLayout.vue?vue&type=template&id=691cf496&scoped=true&"
import script from "./MemberDetailPortfolioLayout.vue?vue&type=script&lang=js&"
export * from "./MemberDetailPortfolioLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691cf496",
  null
  
)

export default component.exports